import { render } from "./RecentAnnouncements.vue?vue&type=template&id=005bb9de&ts=true"
import script from "./RecentAnnouncements.vue?vue&type=script&lang=ts"
export * from "./RecentAnnouncements.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__